import { useEffect } from 'react';

import { setDocumentTitle } from 'dpl/util/dom';
import insertHeadTags from 'dpl/util/insertHeadTags';
import { noop } from 'dpl/shared/utils';
import { get } from 'dpl/shared/utils/object';

export default function usePrismicMetaTags(prismicQuery) {
  useEffect(() => {
    const prismicDocumentData =
      get(prismicQuery, 'article.data') || get(prismicQuery, 'hub.data');
    const tags = [];
    let resetDocumentTitle;

    if (!prismicQuery.isSuccess || !prismicDocumentData) {
      return noop;
    }

    tags.push({
      name: 'meta',
      attributes: {
        name: 'twitter:card',
        content: 'summary_large_image'
      }
    });

    tags.push({
      name: 'meta',
      attributes: {
        name: 'twitter:site',
        content: '@officialgooddog'
      }
    });

    if (prismicDocumentData.seo_title) {
      resetDocumentTitle = setDocumentTitle(prismicDocumentData.seo_title);

      tags.push({
        name: 'meta',
        attributes: {
          name: 'og:title',
          content: prismicDocumentData.seo_title
        }
      });

      tags.push({
        name: 'meta',
        attributes: {
          name: 'twitter:title',
          content: prismicDocumentData.seo_title
        }
      });
    }

    if (prismicDocumentData.seo_description) {
      tags.push({
        name: 'meta',
        attributes: {
          name: 'description',
          content: prismicDocumentData.seo_description
        }
      });

      tags.push({
        name: 'meta',
        attributes: {
          name: 'twitter:description',
          content: prismicDocumentData.seo_description
        }
      });
    }

    if (prismicDocumentData.seo_image) {
      tags.push({
        name: 'meta',
        attributes: {
          name: 'og:image',
          content: prismicDocumentData.seo_image.url
        }
      });

      tags.push({
        name: 'meta',
        attributes: {
          name: 'twitter:image',
          content: prismicDocumentData.seo_image.url
        }
      });

      if (prismicDocumentData.seo_image.alt) {
        tags.push({
          name: 'meta',
          attributes: {
            name: 'og:image:alt',
            content: prismicDocumentData.seo_image.alt
          }
        });
      }
    }

    const removeHeadTags = insertHeadTags(tags);

    return function resetMetaTags() {
      if (resetDocumentTitle) {
        resetDocumentTitle();
      }
      removeHeadTags();
    };
  }, [prismicQuery.isSuccess]);
}
